import { NoticeFactory } from '@b2b/common/factories/notice';
import { ApiService } from '@b2b/common/services/api/types';
import { TODO } from '@b2b/types/core/utils';
import { StateService } from '@uirouter/angularjs';
import angular, { ILogService, IScope } from 'angular';

LoginTokenController.$inject = ['$scope', '$state', '$log', 'ApiService', 'AuthService', 'NoticeFactory'];
function LoginTokenController(
  $scope: IScope & { loginToken: TODO },
  $state: StateService,
  $log: ILogService,
  ApiService: ApiService,
  AuthService: TODO,
  NoticeFactory: NoticeFactory
) {
  const ctrl = {
    notice: new NoticeFactory(),

    init: function () {
      console.log('LoginTokenController::init');

      AuthService.logout().then(ctrl.logout).catch(ctrl.logout);
      ctrl.notice = new NoticeFactory();
    },

    complete: function () {
      ctrl.notice.hideMessages();
      ctrl.notice.startLoad();

      if ($state.params && $state.params.hasOwnProperty('token')) {
        ctrl.notice.startLoad();

        AuthService.confirm({ token: $state.params.token })
          .then((response) => ctrl.success.complete(response))
          .catch((response) => ctrl.error.complete(response));
      }
    },

    logout: function () {
      console.log('LoginTokenController::logout -> Killin cookies');
      ctrl.complete();
    },

    success: {
      complete: function (...response) {
        ctrl.notice.endLoad();
        $scope.$emit('LoginTokenController::login::success', response);
      },
    },

    error: {
      complete: function (response) {
        ctrl.notice.endLoad();
        ctrl.notice.showErrorMessages([{ message: 'There was a problem: ' + response.data.error }]);
      },
    },
  };

  $scope.loginToken = ctrl;
  ctrl.init();
}

export const LoginTokenControllerModule = angular
  .module('acme.view.login.controllers.loginToken', [
    'ui.router',
    'acme.common.service.api',
    'acme.common.service.auth',
    'acme.common.factory.notice',
  ])
  .controller('LoginTokenController', LoginTokenController).name;
